/*global Modernizr, Splide, DDSlideCurrentSlide */
/*jslint browser:true */

(function() {
    'use strict';

    var gallery_sliders = document.querySelectorAll('.gallery-slider');
    if(gallery_sliders) {
      gallery_sliders.forEach((gallery_slider) => {
        const gallery_nav_slider = gallery_slider.nextElementSibling;

        const main = new Splide(gallery_slider, {
          type: 'loop',
          rewind: true,
          pagination: false,
          arrows: false,
          gap: 5
        });

        const thumbnails = new Splide(gallery_nav_slider, {
          fixedWidth: 112,
          fixedHeight: 90,
          rewind: true,
          isNavigation: true,
          gap: 10,
          pagination: false,
          cover: true,
        });

        main.sync( thumbnails );
        main.mount();
        thumbnails.mount({ DDSlideCurrentSlide });
      });
    }
}());
